const MAJOR_EVERY_N_MINOR = 5;

const round2 = (v: number) => Math.round(v * 100) / 100;

/**
 * Builds the two SVG path strings for classic ECG paper:
 * a light line every 1 mm (`minor`) and a heavier line every 5 mm (`major`).
 * Lines that fall on a 5 mm boundary appear only in `major`.
 */
export function buildEcgGridPaths(
  width: number,
  height: number,
  pxPerMm: number,
): { minor: string; major: string } {
  if (width <= 0 || height <= 0 || pxPerMm <= 0) {
    return { minor: "", major: "" };
  }

  const minorParts: string[] = [];
  const majorParts: string[] = [];
  const h = round2(height);
  const w = round2(width);

  const verticalCount = Math.floor(width / pxPerMm);
  for (let i = 0; i <= verticalCount; i++) {
    const x = round2(i * pxPerMm);
    const target = i % MAJOR_EVERY_N_MINOR === 0 ? majorParts : minorParts;
    target.push(`M${x},0V${h}`);
  }

  const horizontalCount = Math.floor(height / pxPerMm);
  for (let i = 0; i <= horizontalCount; i++) {
    const y = round2(i * pxPerMm);
    const target = i % MAJOR_EVERY_N_MINOR === 0 ? majorParts : minorParts;
    target.push(`M0,${y}H${w}`);
  }

  return { minor: minorParts.join(""), major: majorParts.join("") };
}
